// Jobs Actions
export const SAGA_LOAD_JOBS_SUMMARY = 'SAGA_LOAD_JOBS_SUMMARY';
export const SAGA_PATCH_JOB = 'SAGA_PATCH_JOB';

export const SET_JOBS_SUMMARY = 'SET_JOBS_SUMMARY';

export const serverLoadJobsSummary = () => {
    return {
        type: SAGA_LOAD_JOBS_SUMMARY,
        payload: null,
    }
}

export const serverPatchJobPriority = (jobId, priority) => {
    return {
        type: SAGA_PATCH_JOB,
        payload: {
            jobId,
            patchBody: {
                priority,
            }
        }
    }
}

// Validation statistics
export const SAGA_LOAD_VALIDATION_STATISTICS = 'SAGA_LOAD_VALIDATION_STATISTICS';

export const serverLoadValidationStatistics = () => {
    return {
        type: SAGA_LOAD_VALIDATION_STATISTICS,
        payload: {

        }
    }
}

// Accounts Actions

export const SAGA_LOAD_ACCOUNTS = 'SAGA_LOAD_ACCOUNTS';
export const SAGA_CREATE_ACCOUNT = 'SAGA_CREATE_ACCOUNT';

export const SET_ACCOUNTS = 'SET_ACCOUNTS';

export const serverLoadAccounts = () => {
    return {
        type: SAGA_LOAD_ACCOUNTS,
        payload: null,
    }
}

export const serverCreateAccount = (account) => {
    return {
        type: SAGA_CREATE_ACCOUNT,
        payload: {
            account,
        }
    }
}


// WEBPACK FOOTER //
// ./src/admin/actions.js